import Element from "../../../components/base/element";
import Api from "../../../lib/api";

export default class CertificateCheckForm extends Element {
	constructor() {
		super();
		this.$root = document.getElementById('certificateCheckForm');
		this.$input = this.$root.querySelector('[name="certificate"]');
		this.$submit = this.$root.querySelector('[type="submit"]');

		this.url = 'https://lms.ithillel.ua/api/certificates'

		this.value = '';
		this.certificateNumber = '';

		this.CERTIFICATE_CHECK_COMPLETE_EVENT = 'certificateCheckComplete';
	}

	addEventListeners() {
		this.$input.addEventListener('input', (e) => {
			this.value = this.$input.value;

			if (this.value.length) {
				this.$submit.removeAttribute('disabled');
			} else {
				this.$submit.setAttribute('disabled', 'disabled');
			}
		});

		this.$submit.addEventListener('click', (e) => {
			e.preventDefault();
			this.submit();
		});
	}

	submit() {
		this.setCertificateNumber(this.value);
		this.setState('submit');

		setTimeout(() => {
			this.requestCertificateData();
		}, 500);
	}

	requestCertificateData(callback = null) {
		Api.get(this.url, { ref: this.certificateNumber })
			.then((data) => {
				if (!data ||
					(data.hasOwnProperty('success') && data.success == false) ||
					(data.hasOwnProperty('error') && data.error == true))
				{
					this.setState('initial');
					this.showErrorMessage();

					if (callback) {
						callback(false);
					}

					this.dispatchEvent(this.CERTIFICATE_CHECK_COMPLETE_EVENT, false);
					return;
				}

				if (callback) {
					callback(data);
				}

				this.updateUrl();
				this.dispatchEvent(this.CERTIFICATE_CHECK_COMPLETE_EVENT, data);
			});
	}

	setCertificateNumber(value) {
		const trimmed = value.replace(/\s/g, '');
		const prefixTrimmed = trimmed.replace(/^hisk|hiso|hisd|hish/, '');
		this.certificateNumber = prefixTrimmed;
	}

	updateUrl() {
		window.history.replaceState(null, null, `${window.location.origin}${craft.env.lang == 'ru' ? '/ru' : ''}/view/${this.certificateNumber}`);
	}

	setState(state) {
		if (state === 'submit') {
			this.$input.value = '';
			this.$submit.setAttribute('disabled', 'disabled');
			this.$submit.classList.add('-progress');
			this.hideErrorMessage();
		} else if (state === 'initial') {
			this.$input.value = '';
			this.$submit.classList.remove('-progress');
			this.hideErrorMessage();
		}
	}

	showErrorMessage() {
		this.$root.classList.add('-invalid');
	}

	hideErrorMessage() {
		this.$root.classList.remove('-invalid');
	}
}